import * as React from "react";
import { Icons } from '../Misc/Icons';
import { Pane } from 'evergreen-ui';
export function MaterialIcon(props) {
    let Thickness = props.order.selMaterial ? parseFloat(props.order.selMaterial.Thickness) : 0;
    let MATTURL = process.env.AJAXURL + '/assets/materials/';
    return (React.createElement(Pane, { className: "Cart_Material_Icon", display: "flex", justifyContent: "center", alignItems: "center", position: "relative", flex: "0.4", onClick: (e) => { props.onClick(e); } },
        props.order.selMaterial &&
            // <Tooltip content={props.material as string}>
            React.createElement(React.Fragment, null,
                React.createElement("img", { className: "materialIcon_span", style: { width: "75px", height: "100%", borderRadius: "10px 0px 0px 10px" }, src: MATTURL + props.material + '.jpg', alt: "Material Icon" }),
                React.createElement("span", { style: { position: "absolute" }, className: "Thickness" }, Thickness > 0 ? Thickness + 'mm' : ''))
    // </Tooltip>
    ,
        !props.order.selMaterial && Icons.nomaterial));
}
